<template>
  <div>
    <div class="text-3xl mb-8">Rechnungen</div>

    <div class="shadow rounded -mx-4 md:mx-0">
      <div class="p-4 md:p-6 flex justify-between md:justify-start hidden">
        <!-- Search -->
      </div>

      <div class="flex flex-col relative">
        <div
          v-if="invoices.length > 0"
          class="hidden md:flex px-6 py-3 bg-gray-100 text-gray-600 font-semibold uppercase"
        >
          <div class="w-2/6">Rechnung</div>
          <div class="w-2/6">Betrag ohne Steuern</div>
          <div class="w-2/6">Betrag</div>
          <div class="w-2/6 text-right">Status</div>
        </div>

        <a
          :href="invoice.url"
          target="_blank"
          v-for="invoice in invoices"
          :key="invoice.id"
          class="flex py-3 border-t px-4 md:px-6 hover:shadow"
        >
          <div class="w-full md:w-2/6 flex sm:pr-6">
            <div class="w-full min-w-0">
              <div class="flex w-full justify-between">
                <div class="text-gray-800 font-semibold truncate">{{ invoice.name }}</div>
              </div>
              <div class="text-sm text-gray-700">{{ invoice.invoice_date | date }}</div>
            </div>
          </div>

          <div class="w-2/6 self-center hidden md:block">
            <div class="text-gray-700">{{ decimalCurrency(invoice.amount_untaxed_signed) }}</div>
          </div>

          <div class="w-2/6 self-center hidden md:block">
            <div class="text-gray-700">{{ decimalCurrency(invoice.amount_total_signed) }}</div>
          </div>

          <div class="w-full md:w-2/6 flex flex-col md:flex-row justify-end">
            <div class="md:w-1/2 self-end justify-end md:self-center flex">
              <div class="self-center">
                <badge
                  :text="invoice.payment_state == 'paid' ? 'Abgerechnet' : 'Ausstehend'"
                  :type="invoice.payment_state == 'paid' ? 'success' : 'warning'"
                  class="px-1 md:px-4"
                ></badge>
              </div>
            </div>
            <div class="md:hidden text-right text-gray-700 text-sm">
              Betrag: {{ decimalCurrency(invoice.amount_total_signed) }}
            </div>
          </div>
        </a>

        <div v-if="loading" class="spinner"></div>

        <div
          v-if="invoices.length <= 0 && !loading"
          class="py-8 text-center flex flex-col justify-center items-center"
        >
          <img src="../../assets/images/notasks73.svg" alt="Nothing found" />

          <div class="text-2xl mt-6">Keine Rechnungen gefunden</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import invoiceClient from '@/api/merchant/invoices';
import Badge from '@/components/Badge';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      invoices: [],
      loading: true,
    };
  },

  components: { Badge },

  mounted() {
    invoiceClient
      .index()
      .then(({ data }) => (this.invoices = data.data))
      .then(() => (this.loading = false));
  },

  filters: {
    date(value) {
      return dayjs(value).format('dddd, DD.MM.YYYY');
    },
  },

  methods: {
    decimalCurrency(value) {
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

      return formatter.format(value);
    },
  },
};
</script>